import * as reactQuery from "react-query";

const useMutation = (...args) => {
    const mutation = reactQuery.useMutation(...args);

    return mutation;
};

export default useMutation;
